import { useCallback, useLayoutEffect, useMemo, useState } from 'react';

import ImgsViewer from 'react-images-viewer';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'redux/store/store.types';

import { setMediaCurrentPage, useMedia } from 'modules/media';

import Button from '@material-ui/core/Button';

import NibButton from '@components/common/NibButton/NibButton';
import NibTable from '@components/common/NibTable';

export default function GallerySelectImageTable(props) {
  const dispatch = useDispatch(),
    [displayedImage, setDisplayedImage] = useState(null);

  const {
    currentPage,
    items: mediaItems,
    paginationMeta,
    isLoading: isMediaLoading,
    perPage,
    availableCollections,
  } = useAppSelector((store) => store.media);
  const { fetchMediaHandler, convertMediaToFile } = useMedia();

  const fetchMediaItems = useCallback(async () => {
    if (!availableCollections) return;
    if (currentPage > paginationMeta?.last_page) return;
    await fetchMediaHandler({
      page: currentPage,
      per_page: perPage,
      collection: availableCollections,
      withAddItems: true,
    });
  }, [currentPage, perPage, paginationMeta, availableCollections]);

  const columns = useMemo(
    () => [
      {
        Header: 'Thumbnail',
        accessor: 'thumb_url',
        type: 'thumbnail',
        data: {
          onClick: (row) => setDisplayedImage(row),
        },
        props: {
          style: { width: '100px' },
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
        type: 'custom',
        data: {
          onClick: (row) => setDisplayedImage(row),
          render: (value) => {
            return <div style={{ wordBreak: 'break-word' }}>{value}</div>;
          },
        },
      },
      {
        Header: 'Select',
        accessor: 'id',
        type: 'custom',
        props: {
          style: { width: '100px' },
        },
        data: {
          render: (value, rows) => {
            return (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  convertMediaToFile({
                    mimeType: rows.mime_type,
                    name: rows.name,
                    url: rows.url,
                    extension: rows.extension,
                  }).then((file) => {
                    window.__RUG.uploadFiles([file]);
                  });

                  props.setdialogUseButton(true);
                  props.setMainFormDisplay(!props.showMainForm);
                  props.setDialogWeight(props.setUpImageWeightDialog);
                }}
              >
                Add
              </Button>
            );
          },
        },
      },
    ],
    [],
  );

  useLayoutEffect(() => {
    fetchMediaItems();
  }, [currentPage, availableCollections]);

  return (
    <>
      <div
        className="old-container wrap"
        id="images_list_wrap"
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          position: 'relative',
          overflowX: 'hidden',
        }}
      >
        <div className={'box col '} style={{ width: '90%', margin: '0 auto' }}>
          <NibTable
            scrollableTargetId={'images_list_wrap'}
            isLoading={isMediaLoading}
            perPage={perPage}
            infi={true}
            end={paginationMeta?.current_page == paginationMeta?.last_page}
            columns={columns}
            data={mediaItems}
            update={() => dispatch(setMediaCurrentPage(currentPage + 1))}
            readOnly
          />
        </div>
      </div>
      {displayedImage && (
        <ImgsViewer
          imgs={[
            {
              src: displayedImage.url,
            },
          ]}
          isOpen={displayedImage}
          onClose={() => setDisplayedImage(null)}
          backdropCloseable
          customControls={[
            <NibButton
              filled
              label="Download"
              onClick={() => {
                convertMediaToFile({
                  mimeType: displayedImage.mime_type,
                  name: displayedImage.name,
                  url: displayedImage.url,
                  withDownload: true,
                  extension: displayedImage.extension,
                }).then((file) => {
                  window.__RUG.uploadFiles([file]);
                });
              }}
            />,
          ]}
        />
      )}
    </>
  );
}
